module.exports = __webpack_public_path__ + "static/media/044-Two Amigos.8644773a.jpeg";